// VIVA-1214 — normalización de las respuestas del cobro de guías.
//
// Lee cada campo en camelCase o PascalCase (mismo criterio que
// useGuides2Catalog): el backend serializa en camelCase, pero sus DTO están en
// PascalCase y un cambio de serializador no debe dejar el panel vacío.

const pick = (source, name) => {
  const pascal = name.charAt(0).toUpperCase() + name.slice(1);
  return source?.[name] ?? source?.[pascal];
};

const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

// data de GET /api/guia/precio-preview. Forma comprobada contra pre el
// 22/09/2026 con la guía 26:
// { guideId, currencyCode, basePrice, isBeta, betaDiscountPercent,
//   betaDiscountAmount, couponCode, couponValid, couponReasonCode,
//   couponDiscountAmount, totalAmountUsd, flooredApplied }
//
// `couponValid` es null cuando no se mandó cupón, false con motivo en
// `couponReasonCode` (visto: NOT_FOUND) y true cuando aplica.
export const mapGuidePricePreview = (data) => {
  if (!data) return null;

  const couponValid = pick(data, "couponValid");

  return {
    guideId: pick(data, "guideId"),
    currencyCode: pick(data, "currencyCode") || "USD",
    basePrice: toNumber(pick(data, "basePrice")),
    isBeta: pick(data, "isBeta") === true,
    betaDiscountPercent: toNumber(pick(data, "betaDiscountPercent")),
    betaDiscount: toNumber(pick(data, "betaDiscountAmount")),
    couponCode: pick(data, "couponCode") || null,
    couponValid: couponValid === true ? true : couponValid === false ? false : null,
    couponReasonCode: pick(data, "couponReasonCode") || null,
    couponDiscount: toNumber(pick(data, "couponDiscountAmount")),
    total: toNumber(pick(data, "totalAmountUsd")),
    floorApplied: pick(data, "flooredApplied") === true,
  };
};

// data de POST /api/create-payment-intent-generico.
export const mapGuidePaymentIntent = (data) => ({
  paymentIntentId: pick(data, "paymentIntentId") || null,
  clientSecret: pick(data, "clientSecret") || null,
});

// data de GET /api/payment-intent/{id}/status.
//
// Forma REAL, comprobada contra pre el 25/09/2026 con un pago completado:
//   { paymentIntentId, status: "PAID", stripeStatus: "succeeded",
//     amount: 499, currency: "usd", entityType: "GUIDE", entityId: "55" }
// `amount` va en centavos y `status` es el estado en la base de datos, en
// mayúsculas; `stripeStatus` es el de Stripe, en minúsculas.
//
// NO DEVUELVE `hasAccess`, y `status: "PAID"` NO equivale a tenerlo: en esa
// misma prueba la primera consulta ya respondía PAID mientras la guía todavía
// no figuraba en mis-guias-compradas. Deducir el acceso de PAID le habría dicho
// al comprador "ya puedes leerla" con la tarjeta todavía bloqueada. Por eso el
// acceso solo se da por bueno si backend lo afirma con un campo propio, y
// mientras ese campo no exista la espera de `waitForPaymentAccess` la resuelve
// mis-guias-compradas. Si backend agrega `hasAccess`, la espera se vuelve
// inmediata sin tocar nada más.
export const mapPaymentIntentStatus = (data) => ({
  status: String(
    pick(data, "status") ?? pick(data, "paymentStatus") ?? pick(data, "stripeStatus") ?? ""
  ).toLowerCase(),
  hasAccess: pick(data, "hasAccess") === true || pick(data, "accessGranted") === true,
});
